import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import FactoryIcon from "@mui/icons-material/Factory";
import InventoryIcon from "@mui/icons-material/Inventory";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import React from "react";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { ICSDrawerContents } from "@ntg/component-library/declarations";

export const DrawerContents: ICSDrawerContents = {
    Items: [
        {
            DrawerItems: [
                {
                    Icon: <DashboardIcon color="primary" />,
                    PrimaryText: "Dashboard",
                    ShowMobile: true,
                    To: "/home",
                },
            ],
            ShowTitle: false,
            Title: "",
        },
        {
            DrawerItems: [
                {
                    Icon: <ContentCutIcon color="secondary" />,
                    PrimaryText: "Processes",
                    ShowMobile: false,
                    To: "/processes",
                },
                {
                    Icon: <InventoryIcon color="secondary" />,
                    PrimaryText: "Material Predictions",
                    ShowMobile: false,
                    To: "/materialpredictions",
                },
                {
                    Icon: <AccessTimeIcon color="secondary" />,
                    PrimaryText: "Process Hours",
                    ShowMobile: false,
                    To: "/hours",
                },
            ],
            ShowTitle: true,
            Title: "Sail Configurations",
        },
        {
            DrawerItems: [
                {
                    Icon: <PrecisionManufacturingIcon color="secondary" />,
                    PrimaryText: "Site Capabilities",
                    ShowMobile: false,
                    To: "/sitecapabilities",
                },
                {
                    Icon: <FactoryIcon color="secondary" />,
                    PrimaryText: "Site Allocations",
                    ShowMobile: false,
                    To: "/siteallocations",
                },
                {
                    Icon: <WarehouseIcon color="secondary" />,
                    PrimaryText: "Site Capacities",
                    ShowMobile: false,
                    To: "/sitecapacities",
                },
                {
                    Icon: <DepartureBoardIcon color="secondary" />,
                    PrimaryText: "Transit Times",
                    ShowMobile: false,
                    To: "/transit",
                },
            ],
            ShowTitle: true,
            Title: "Site Management",
        },
    ],
};
